// extracted by mini-css-extract-plugin
export default {"shareButtons":"SocialShareButton_shareButtons__XyJmi","linkButtons":"SocialShareButton_linkButtons__tnqK6","buttonPadding":"SocialShareButton_buttonPadding__xx1FM"};